/**
 * Canonical observation category list — single source of truth for the
 * Observations module frontend.
 *
 * Per client requirement, only two categories exist:
 *   UA – Unsafe Act
 *   UC – Unsafe Condition
 *
 * Stored values are the full names ('Unsafe Act' / 'Unsafe Condition') —
 * matching the backend observations.observation_category CHECK constraint —
 * and displayed with their UA/UC prefixes. A NULL/empty category can only
 * appear on legacy records migrated from Incident Management (whose type was
 * the retired plain 'Observation' value) and renders as 'Unclassified'.
 */

export const OBSERVATION_CATEGORIES = [
  { value: 'Unsafe Act', label: 'UA – Unsafe Act' },
  { value: 'Unsafe Condition', label: 'UC – Unsafe Condition' },
];

/**
 * Display label for a stored observation_category value. NULL/empty →
 * 'Unclassified' (legacy migrated records); unknown values render as-is.
 */
export function observationCategoryLabel(value) {
  if (!value) return 'Unclassified';
  const match = OBSERVATION_CATEGORIES.find((c) => c.value === value);
  return match ? match.label : value;
}
